<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">
        {{'Update User Group' | translate}}
    </h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
        <li class="breadcrumb-item position-relative">
            {{'Users' | translate}}
        </li>
        <li class="breadcrumb-item position-relative">
            {{'Update User Group' | translate}}
        </li>
    </ol>
</div>

<mat-card class="daxa-card users-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
            {{'Update User Group' | translate}}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="editUserGroupForm" (ngSubmit)="onUpdateUserGroup()">
            <mat-form-field>
                <mat-label>{{'Title' | translate}}</mat-label>
                <input matInput formControlName="title" />
                <mat-error *ngIf="editUserGroupForm.get('title')?.invalid">
                    {{'Title is required' | translate}}
                </mat-error>
            </mat-form-field>

            <div class="roles">
                <h5>{{'Roles' | translate}}:</h5>
                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree bg-white">
                    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
                        <mat-checkbox [checked]="selectedRoles.includes(node.id)"
                            (change)="toggleRoleSelection(node.id, $event.checked)">
                            {{ node.title }}
                        </mat-checkbox>
                    </mat-tree-node>

                    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                        <div class="mat-tree-node">
                            <button type="button" mat-icon-button matTreeNodeToggle
                                [attr.aria-label]="'Toggle ' + node.title">
                                <mat-icon>{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'
                                    }}</mat-icon>
                            </button>

                            <mat-checkbox [checked]="areAllChildrenChecked(node)"
                                [indeterminate]="areSomeChildrenRoleChecked(node) && !areAllChildrenChecked(node)"
                                (change)="toggleAllRoles(node, $event.checked)">
                                {{ node.title }}
                            </mat-checkbox>
                        </div>

                        <div *ngIf="treeControl.isExpanded(node)" role="group">
                            <ng-container matTreeNodeOutlet></ng-container>
                        </div>
                    </mat-nested-tree-node>
                </mat-tree>
            </div>
            <div class="buttons-container">
                <button mat-raised-button class="daxa" type="submit" [disabled]="
                        editUserGroupForm.invalid ||
                        selectedRoles.length === 0 ||
                        isLoading
                    ">
                    {{ isLoading ? "Loading..." : ("Save" | translate) }}
                </button>
                <button mat-raised-button type="button" color="warn" routerLink="/users/user-groups">
                    {{'Cancel' | translate}}
                </button>
            </div>
        </form>
    </mat-card-content>
    <div class="alert alert-bg-danger d-flex justify-content-between align-items-center" role="alert"
        *ngIf="errorMessage">
        {{ errorMessage }}
        <button type="button" class="close bg-transparent text-white p-0 border-none" data-dismiss="alert"
            aria-label="Close" (click)="closeAlert()">
            <i class="ri-close-line"></i>
        </button>
    </div>
    <div class="alert alert-bg-success d-flex justify-content-between align-items-center" role="alert"
        *ngIf="SucessMessage">
        {{'User Group updated successfully' | translate}}
        <button type="button" class="close bg-transparent text-white p-0 border-none" data-dismiss="alert"
            aria-label="Close" (click)="closeAlert()">
            <i class="ri-close-line"></i>
        </button>
    </div>
</mat-card>